import React, { Component } from "react";
import FeaturesCompare from "./widgets/FeaturesCompare";
import ModelList from "./widgets/ModelList";
import { connect } from "react-redux";

//import { changeRefrigerant } from "../stores/actions/compareModels";

class CompareModels extends Component {
  state = {
    compare_data: {},
    selected_refrigerant: "R-448A",
    groupnames: [
      "General",
      "Efficiency",
      "Safety",
      "Dimensions",
      "Electrical Ratings",
      "Connections Data",
      "Other technical Data"
    ],
    selected_system: "imperial",
    toggleOn: this.props.toggleOn,
    showA2l: (this.props.compare?.doe && this.props.compare?.doe.length === 0),
    isLegacyModel: (this.props.compare?.doe && this.props.compare?.doe.length > 0),
    selected_a2l_refrigerant: "R-455A"
  };

  //Handle Model Number change
  componentDidUpdate(prevProps) {  
    if (prevProps.autosuggest.value !== this.props.autosuggest.value || prevProps.compare.doe !== this.props.compare.doe) {
  
      this.setState({
        selected_refrigerant: 'R-448A',
        selected_a2l_refrigerant: 'R-455A',
        toggleOn: false,
        showA2l: (this.props.compare?.doe && this.props.compare?.doe.length === 0),
        isLegacyModel: (this.props.compare?.doe && this.props.compare?.doe.length > 0)
      });
    }
    if(this.state.isLegacyModel && this.props.toggleOn  !== this.state.showA2l) {
      this.showA2l();
    }
  }

  convertRefrigerants = (item, type) => {
    if (item === "R-448A" && type === "PRO3") {
      return "R-404A";
    }
  };

  updatedata = () => {
    var compare_data = {};
    for (var i = 0; i < this.state.groupnames.length; i++) {
      compare_data[this.state.groupnames[i].toLowerCase()] = [];
    }
    var slected_refrigerant_properties_legacy = this.props.compare.legacy.refrigerants.filter(
      item => {
        if (item.id === this.state.selected_refrigerant) {
          return item;
        }
      }
    );


    var slected_refrigerant_properties_doe = [];

    for (var i = 0; i < this.props.compare.doe.length; i++) {
      slected_refrigerant_properties_doe.push(
        ...this.props.compare.doe[i].refrigerants.filter(item => {
          if (item.id === this.state.selected_refrigerant) {
            return item;
          }
        })
      );
    }
    slected_refrigerant_properties_doe.map(p => {

      return p.properties
        .map(p_prop => {


          for (var i = 0; i < this.state.groupnames.length; i++) {
            if (
              p_prop.group.toLowerCase() ===
              this.state.groupnames[i].toLowerCase()
            ) {
              var found_key = false;
              for (
                var j = 0;
                j < compare_data[this.state.groupnames[i].toLowerCase()].length;
                j++
              ) {
                if (
                  compare_data[this.state.groupnames[i].toLowerCase()][j]
                    .key === p_prop.key
                ) {
                  compare_data[this.state.groupnames[i].toLowerCase()][
                    j
                  ].value.doe.push(p_prop.value);
                  found_key = true;
                }
              }
              if (!found_key) {
                compare_data[this.state.groupnames[i].toLowerCase()].push({
                  key: p_prop.key,
                  value: { doe: [p_prop.value] }
                });
              }
            }
          }
        })
        .filter(item => {
          if (typeof item != "undefined ") return item;
        });
    });

    var slected_refrigerant_properties_a2l = [];

    for (var i = 0; i < this.props.compare.a2l.length; i++) {
      slected_refrigerant_properties_a2l.push(
        ...this.props.compare.a2l[i].refrigerants.filter(item => {
          if (item.id === this.state.selected_refrigerant) {
            return item;
          }
        })
      );
    }

    slected_refrigerant_properties_a2l.map(p => {
      return p.properties
        .map(p_prop => {
          for (var i = 0; i < this.state.groupnames.length; i++) {
            if (
              p_prop.group.toLowerCase() ===
              this.state.groupnames[i].toLowerCase()
            ) {
              var found_key = false;
              for (
                var j = 0;
                j < compare_data[this.state.groupnames[i].toLowerCase()].length;
                j++
              ) {
                if (
                  compare_data[this.state.groupnames[i].toLowerCase()][j]
                    .key === p_prop.key
                ) {
                  compare_data[this.state.groupnames[i].toLowerCase()][
                    j
                  ].value.a2l.push(p_prop.value);
                  found_key = true;
                }
              }
              if (!found_key) {
                compare_data[this.state.groupnames[i].toLowerCase()].push({
                  key: p_prop.key,
                  value: { a2l: [p_prop.value] }
                });
              }
            }
          }
        })
        .filter(item => {
          if (typeof item != "undefined ") return item;
        });
    });


    slected_refrigerant_properties_legacy.map(p => {

      return p.properties
        .map(p_prop => {


          for (var i = 0; i < this.state.groupnames.length; i++) {
            if (
              p_prop.group.toLowerCase() ===
              this.state.groupnames[i].toLowerCase()
            ) {
              var found_key = false;
              for (
                var j = 0;
                j < compare_data[this.state.groupnames[i].toLowerCase()].length;
                j++
              ) {
                if (
                  compare_data[this.state.groupnames[i].toLowerCase()][j]
                    .key === p_prop.key
                ) {
                  compare_data[this.state.groupnames[i].toLowerCase()][
                    j
                  ].value.legacy = p_prop.value;
                  found_key = true;
                }
              }
              if (!found_key) {
                compare_data[this.state.groupnames[i].toLowerCase()].push({
                  key: p_prop.key,
                  value: { legacy: p_prop.value }
                });
              }
            }
          }
        })
        .filter(item => {
          if (typeof item != "undefined ") return item;
        });
    });

    this.setState({ compare_data });
  };

  fetchNomen = nomenclature_name => {

    for (var i = 0; i < this.props.compare.nomenclature.length; i++) {

      if (this.props.compare.nomenclature[i].name === nomenclature_name) {
        return this.props.compare.nomenclature[i];
      }
    }
    return null;
  };

  changeRefrigerant = e => {
    //props.changeRefrigerant();
    const selectedRefrigerant = e.target.value;
    this.setState({ 
      selected_refrigerant: selectedRefrigerant
    });

    if(this.state.isLegacyModel && this.state.showA2l) {
      this.setState({ selected_a2l_refrigerant: selectedRefrigerant });
    }
    
    //this.updatedata();
    // let unique = [...new Set(groups)];
  };

  changeA2lRefrigerant = e => {
    const selectedRefrigerant = e.target.value;
    this.setState({ selected_a2l_refrigerant: selectedRefrigerant });
  }
  getAWEFmessage = (type, modelno, AWEF, refrigerant) => {
    let ref_message = <div></div>;


    if (AWEF === "X")
      ref_message = (
        <li>
          <b>{modelno}</b> is not suitable for this refrigerant.
        </li>
      );
    else if (AWEF === "-")
      ref_message = (
        <li>
          <b>{modelno}</b> does not meet DOE minimum AWEF for {refrigerant} refrigerant.
        </li>
      );
    else if (AWEF === "")
      ref_message = (
        <li>
          <b>{modelno}</b> is not suitable for {refrigerant} refrigerant.
        </li>
      );
    else if (AWEF === "EXEMPT")
      ref_message = (
        <li>
          <b>{modelno}</b> is exempted from DOE compliance.
        </li>
      );
    else if (isNaN(AWEF.replace(/,/g, "")) === false) {
      if (
        type == "HCU" ||
        type == "VCU" ||
        type == "DVCU" ||
        type == "VCU_DVCU" ||
        type == "HTS"
      ) {
        if (modelno[7] === "L") {
          ref_message = (
            <li>
              <b>{modelno}</b> is designed and certified for use in walk-in
              freezer applications for {refrigerant} refrigerant.
            </li>
          );
        } else if (modelno[7] === "M") {
          ref_message = (
            <li>
              <b>{modelno}</b> is designed and certified for use in walk-in
              cooler applications for {refrigerant} refrigerant.
            </li>
          );
        }
      } else if (
        type == "LOP" ||
        type == "CM" ||
        type == "LVCM" ||
        type == "LUC" ||
        type == "MP"
      ) {
        if (modelno[10] === "E" || modelno[10] === "H") {
          ref_message = (
            <li>
              <b>{modelno}</b> is designed and certified for use in walk-in
              freezer applications for {refrigerant} refrigerant.
            </li>
          );
        } else if (modelno[10] === "A") {
          ref_message = (
            <li>
              <b>{modelno}</b> is designed and certified for use in walk-in
              cooler applications for {refrigerant} refrigerant.
            </li>
          );
        }
      }
    }

    return ref_message;
  };

  componentDidMount() {
    if (this.state.selected_refrigerant === "") {
      this.setState({
        selected_refrigerant: this.props.compare.refrigerents[0]
      });
    }
  }

  showA2l = () => {
    this.setState(prevState => ({ showA2l: this.props.toggleOn, toggleOn: this.props.toggleOn, selected_refrigerant: (this.state.isLegacyModel && this.props.toggleOn) ? "R-455A" : "R-448A", })); 
  }

  showA2lModels = () => {
    this.setState(
      (prevState) => ({
        showA2l: !prevState.showA2l,
        toggleOn: !prevState.toggleOn,
      }),
      () => {
        // Use the updated state here
        if (this.state.isLegacyModel) {
          this.setState({
            selected_refrigerant: this.state.showA2l ? "R-455A" : "R-448A",
          });
        }
        this.props.handleToggleChange(this.state.toggleOn); // Notify parent about the toggle change
      }
    );
  }

  render() {
    // if (
    //   this.state.selected_refrigerant !== "R-448A" &&
    //   this.props.compare.type === "PRO3"
    // ) {
    //   this.setState({ selected_refrigerant: "R-448A" });
    //   //alert("done");
    //   return <div></div>;
    // }

// LUC family verbiage for Fan Diameter 30 condition
var nochangelegacy = false;
let nonochangelegacyMsg=false;
if(this.state.selected_refrigerant !== "R-454A" && this.state.selected_refrigerant !== "R-454C" && this.state.selected_refrigerant !== "R-455A"){
       if (this.props.compare.type === "LUC") {
          if (this.props.compare.doe.length > 0) {
          const fanDiameter = parseInt(
            this.props.compare.doe[0].refrigerants[
            this.state.selected_refrigerant
            ]["Electrical Ratings"]["Fan Diameter"]["imperial"].replace(",", "")
          );
          if (fanDiameter === 30) {
            nonochangelegacyMsg = true;
          }
          }   
     }  
     else{
        if (this.props.compare.type === "LUC" && this.props.compare.a2l.length > 0) {
              const fanDiameter = parseInt(
                this.props.compare.a2l[0].refrigerants[
                this.state.selected_refrigerant
                ]["Electrical Ratings"]["Fan Diameter"]["imperial"].replace(",", "")
              );
              if (fanDiameter === 30) {
                nonochangelegacyMsg = true;
              }
              }
          }
    }

    var ref_Data = [];
    if (this.props.compare.type === "PRO3") {
      ref_Data = [
        {
          key: "Refrigerant",
          value: {
            legacy: this.state.isLegacyModel ? { imperial: "R-404A", metric: "R-404A" } : { imperial: this.state.selected_refrigerant, metric: this.state.selected_refrigerant },
            doe: [{ imperial: this.state.selected_refrigerant, metric: this.state.selected_refrigerant }],
            a2l: [{ imperial: "R-455A", metric: "R-455A" }]
          }
        }
      ];
    }

    let hfc_refrigerants = this.props.compare?.refrigerents.map(item => {
      if(item !== "R-454A" && item !== "R-454C" && item !== "R-455A") {
      return (
        <option key={this.props.compare.legacy.modelno + item} value={item}>
          {item}
        </option>
      );
    }
  });
  let a2l_refrigerants = [];

  a2l_refrigerants = this.props.compare?.refrigerents.map(item => {
    if(item === "R-454A" || item === "R-454C" || item === "R-455A") {
    return (
      <option key={this.props.compare.legacy.modelno + item} value={item}>
        {item}
      </option>
    );
  }
});
    let ref_message = [];

    ref_message.push(
      ...this.props.compare.doe.map((item, index) => {
        var message;
        
        //Handle A2L refrigerant selection
        if(this.state.selected_refrigerant === "R-454A" || this.state.selected_refrigerant === "R-454C" || this.state.selected_refrigerant === "R-455A"){
           message = this.getAWEFmessage(
            this.props.compare.type,
            item.modelno,
            item.refrigerants[this.props.compare?.refrigerents[0]].Efficiency.AWEF.metric,
            this.state.selected_refrigerant
          );
        }
        else{
          message = this.getAWEFmessage(
            this.props.compare.type,
            item.modelno,
            item.refrigerants[this.state.selected_refrigerant].Efficiency.AWEF.metric,
            this.state.selected_refrigerant
          );
        }
        if (nonochangelegacyMsg) message = "This model is not changing and is not DOE compliant";

        return message;
      })
    );

    ref_message.push(
      ...this.props.compare.a2l.map((item, index) => {
        var message = this.getAWEFmessage(
          this.props.compare.type,
          item.modelno,
          item.refrigerants[this.state.selected_a2l_refrigerant].Efficiency.AWEF.metric,
          this.state.selected_a2l_refrigerant
        );
        if (nonochangelegacyMsg) message = "This model is not changing and is not A2L compliant";
    
        return message;
      })
    );


    const doelist = this.props.compare.doe.map((doe, i, arr) => {
      let modelno = doe.modelno;

      if (doe.modelno.toUpperCase().startsWith("M"))
        modelno = modelno.replace("M", "⍦");
      if(this.props.compare.doe.length > 2){
        if(i % 2 == 0) {
          return (
            <React.Fragment key={doe.modelno}>
              <li className="vs-li">
                <div className="vs">VS</div>
              </li>
              <li>
                <label className="newmodel_compare">
                  New Model Number
                  <span
                    className={
                      "Compare_" +
                      doe.compliant_flag
                        .replace(" ", "_")
                        .replace("-1", "")
                        .replace("-2", "")
                    } style={{
                      height: "11px",
                      width: "14%"
                    }}
                  >
                  </span>
                </label>
                <div className={"box-doe"}>{modelno} </div>
                {arr[i + 1] && (
                  <>
                    <label className="newmodel_compare" style={{marginTop: '10px'}}>
                      New Model Number
                      <span
                        className={
                          "Compare_" +
                          arr[i+1].compliant_flag
                            .replace(" ", "_")
                            .replace("-1", "")
                            .replace("-2", "")
                        } style={{
                          height: "11px",
                          width: "14%"
                        }}
                      >
                      </span>
                    </label>
                    <div className={"box-doe"}>{arr[i+1].modelno} </div>
                  </>
                )}
              </li>
            </React.Fragment>
          );
        }
        else{
          return null;
        }
      }
      else {
        return (
          <React.Fragment key={doe.modelno}>
            <li className="vs-li">
              <div className="vs">VS</div>
            </li>
            <li>
              <label className="newmodel_compare">
                New Model Number
                <span
                  className={
                    "Compare_" +
                    doe.compliant_flag
                      .replace(" ", "_")
                      .replace("-1", "")
                      .replace("-2", "")
                  } style={{
                    height: "11px",
                    width: "14%"
                  }}
                >
                </span>
              </label>
              <div className={"box-doe"}>{modelno} </div>
            </li>
          </React.Fragment>
        );
      }
    });

    const a2llist = this.props.compare.a2l.map((a2l, i, arr) => {
      let modelno = a2l.modelno;
    
      if (a2l.modelno.toUpperCase().startsWith("M"))
        modelno = modelno.replace("M", "⍦");
    
      if(this.props.compare.a2l.length > 2){
        if(i % 2 == 0) {
          return (
            <React.Fragment key={a2l.modelno}>

              {this.state.isLegacyModel && <li className="vs-li">
                <div className="vs">VS</div>
              </li>}
              <li>
                <label className="newmodel_compare">
                  A2L Model Number
                  <span
                    className={
                      "Compare_" +
                      a2l.compliant_flag
                        .replace(" ", "_")
                        .replace("-1", "")
                        .replace("-2", "")
                    }
                    style={{
                      height: "11px",
                      width: "14%"
                    }}
                  ></span>
                </label>
                <div className={"box-a2l"}>{modelno} </div>
                {arr[i + 1] && (
                  <>
                    <label className="newmodel_compare" style={{marginTop: '10px'}}>
                      A2L Model Number
                      <span
                        className={
                          "Compare_" +
                          arr[i + 1].compliant_flag
                            .replace(" ", "_")
                            .replace("-1", "")
                            .replace("-2", "")
                        }
                        style={{
                          height: "11px",
                          width: "14%"
                        }}
                      ></span>
                    </label>
                    <div className={"box-a2l"}>{arr[i + 1].modelno}</div>
                  </>
                )}
              </li>
            </React.Fragment>
          );
        }
        else{
          return null;
        }
      }
      else {
        return (
        <React.Fragment key={a2l.modelno}>

          {this.state.isLegacyModel && <li className="vs-li">
            <div className="vs">VS</div>
          </li>}
          <li>
            <label className="newmodel_compare">
              A2L Model Number
              <span
                className={
                  "Compare_" +
                  a2l.compliant_flag
                    .replace(" ", "_")
                    .replace("-1", "")
                    .replace("-2", "")
                }
                style={{
                  height: "11px",
                  width: "14%"
                }}
              ></span>
            </label>
            <div className={"box-a2l"}>{modelno} </div>
          </li>
        </React.Fragment>
      );
      }
    });
    function isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    }
    var hold_legacy = ((this.props.compare.legacy.modelno).split(" ("))[0].trim();
    var hold_new = ((this.props.autosuggest.value).split(" ("))[0].trim();
    var hold_type = this.props.compare.type;
    const groups = this.state.groupnames.map((name, index) => {
      if (
        typeof this.props.compare.map_data[this.state.selected_refrigerant] !=
        "undefined"
      ) {

        if (
          !isEmpty(
            this.props.compare.map_data[this.state.selected_refrigerant][name]
          )
        ) {
          return (
            <div key={name + index}>
              <FeaturesCompare
                title={name}
                selected_system={this.state.selected_system}
                nochangelegacy={nochangelegacy}
                data={
                  this.props.compare.map_data[this.state.selected_refrigerant][
                  name
                  ]
                }
                a2l_data={this.props.compare.map_data[this.state.selected_a2l_refrigerant][
                  name
                ]}
                state={this.state}
              />
            </div>
          );
        } else {
          return <React.Fragment></React.Fragment>;
        }
      }
    });

    var oneproductclass = "";

    if (this.props.compare.doe.length === 1) {
      oneproductclass = "one-product";
    }

    // if (this.props.compare.al2.length === 1) {
    //   oneproductclass = "one-product";
    // }

    // const refregerents =  this.props.compare.
    console.log("this.state",  this.state);

    return (
      <div key={this.props.autosuggest.value + '_' + (this.props.compare.legacy?.modelno || '')}>
        <div className={"tab-wrapper-section " + oneproductclass}>
          {/*<ModelList
            setModel={this.props.setModel}
            legacy={this.props.compare.legacy}
            doe={this.props.compare.doe}
          />*/}

          <div className="brand-differents-compare">
            <ul className="awefnotes">
              <li>
                <h2>AWEF Notes</h2>
              </li>

              {this.state.showA2l
                ? ref_message.length < 2 ? ref_message.map((message) =>{return message;}) :ref_message.slice(Math.ceil(ref_message.length/2), ref_message.length).map((message) =>{return message;})
                : ref_message.length < 2 ? ref_message.map((message) =>{return message;}) : ref_message.slice(0, Math.ceil(ref_message.length/2)).map((message) =>{return message;})
              }
            </ul>
            {this.state.isLegacyModel && <div className="compareData-toggle">
              <p>Show A2L Models</p>
              <label className="switch">
                  <input type="checkbox" checked={this.state.toggleOn} onChange={this.showA2lModels}/>            
                  <span className="slider round"></span>
              </label>
            </div>}
            <ul className="compare-list">
              <li>
                {((this.state.isLegacyModel && !this.state.showA2l) || !this.state.isLegacyModel) && <label>HFC Refrigerant</label>}
                {this.state.isLegacyModel && this.state.showA2l && <label>A2L Refrigerant</label>}
                <select
                  value={this.state.selected_refrigerant}
                  onChange={this.changeRefrigerant}
                >
                  {!this.state.isLegacyModel && hfc_refrigerants}
                  {this.state.isLegacyModel && !this.state.showA2l && hfc_refrigerants}
                  {this.state.isLegacyModel && this.state.showA2l && a2l_refrigerants}
                </select>
              </li>
              <li style={(nochangelegacy) ? { width: "65%" } : {}} >
                {this.state.isLegacyModel && <label>Legacy Model</label>}
                {!this.state.isLegacyModel && <label>New Model Number</label>}
                <div className="box-legacy">
                  {this.props.compare.legacy.modelno}
                </div>
              </li>
              {!this.state.showA2l && (!nochangelegacy) ? doelist : <React.Fragment />}
              {this.state.isLegacyModel && this.state.showA2l && (!nochangelegacy) ? a2llist : <React.Fragment />}
            </ul>
            <ul className="compare-list" style={{ "margin-top": "20px" }}>
              {!this.state.isLegacyModel && <li><label>A2L Refrigerant</label>
                <select
                  value={this.state.selected_a2l_refrigerant}
                  onChange={this.changeA2lRefrigerant}
                >
                  {a2l_refrigerants}
                </select>
              </li>}
              {!this.state.isLegacyModel && this.state.showA2l && (!nochangelegacy) ? a2llist : <React.Fragment />}
            </ul>
            <div className="compliant-legend" style={{ "margin-top": "10px" }}>
              <small id="emailHelp" style={{ float: "left" }} className="form-text text-muted">
                <div className="Compliant">Meets minimum AWEF</div>
              </small>
              <small id="emailHelp" className="form-text text-muted">
                <div className="Non-Compliant">Does not meet minimum AWEF</div>
              </small>
            </div>
          </div>
          <div className="brand-copare-list">
            {ref_Data.length > 0 ? (
              <div>
                <FeaturesCompare
                  title="Refrigerant"
                  selected_system={this.state.selected_system}
                  data={ref_Data}
                  nochangelegacy={nochangelegacy}
                  state={this.state}
                />
              </div>
            ) : (
              <div></div>
            )}
           {!this.state.isLegacyModel && <ul
              className="compare-list all-list compare-lis"
            >
              <li>
                <label>&nbsp;</label>
                <span>Model Number</span>
              </li>

              <React.Fragment>
                {nochangelegacy ? (
                  <React.Fragment />
                ) : (
                    <>
                    <li className="model_compare">
                      <label>New Model Number</label>
                      <p>{this.props.compare.legacy.modelno}</p>
                    </li>
                    <li className="vs-li">&nbsp;</li>
                    {this.props.compare.a2l.map((a2l, index) => {
                      let modelno = a2l.modelno;
                      return (
                        <li key={index} className="model_compare">
                          <label className="newmodel_compare">
                            A2L Model Number
                            <span
                              className={
                                "Compare_" +
                                a2l.compliant_flag
                                  .replace(" ", "_")
                                  .replace("-1", "")
                                  .replace("-2", "")
                              }
                              style={{
                                height: "11px",
                                width: "14%",
                                float: "right",
                                border: "0"
                              }}
                            ></span>
                          </label>
                          <p>{modelno}</p>
                        </li>
                      
                      );
                    })}
                  </>
                )}
              </React.Fragment>

            </ul> }
            {groups}
          </div>
          <p className="comp-model-footer">*Capacities shown are Application Capacities reflecting nominal operation at 10°F TD.  For models within the scope of the DOE AWEF (Annual Walk-in Energy Factor) standard, the Net Capacity is determined by the AHRI 1250 test method.  DOE will publish this compliance data at www.regulations.doe.gov.</p>
        </div>
      </div>
    );


  }
}

function mapStateToProps(state) {
  return state;
}
/*const mapDispatchToProps = dispatch => {
  return {
    changeRefrigerant: refrigerant => dispatch(changeRefrigerant(refrigerant))
  };
};*/
//mapDispatchToProps
export default connect(mapStateToProps)(CompareModels);
